import React from 'react'
import { Ring } from 'react-spinners-css'
import './ring.css'
export const LoadingRing = (props) => (
  <div className="loading-resposta">
    <Ring color="#ed3238" size={50} className="ring" />
    <p>{props.title}</p>
  </div>
)
